import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { SmartSmsClubFileProgressStatus } from '../api/models';

@Directive({
  selector: '[smartSmsFileProgressStatusIcon]',
  standalone: true,
})
export class SmartSmsFileProgressStatusIconDirective implements OnInit {
  @Input('smartSmsFileProgressStatusIcon')
  status: SmartSmsClubFileProgressStatus;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi ';

    switch (this.status) {
      case SmartSmsClubFileProgressStatus.Finished:
        classList += 'mdi-check-circle-outline text-success mdi-21px';
        break;
      case SmartSmsClubFileProgressStatus.Extracting:
        classList += 'mdi-export text-info mdi-22px';
        break;
      case SmartSmsClubFileProgressStatus.FileInvalid:
        classList += 'mdi-file-document-alert-outline text-warning mdi-spin mdi-22px';
        break;
      case SmartSmsClubFileProgressStatus.ServerError:
        classList += 'mdi-alert-circle text-danger mdi-spin mdi-22px';
        break;
      case SmartSmsClubFileProgressStatus.NotStarted:
        classList += 'mdi-play-circle-outline text-warning mdi-22px';
        break;

      default:
        break;
    }

    return classList;
  }
}
